<div *ngIf="sampleStr" class="boxwrapper mono padded">
  <micro-ace-editor class="mono boxwrapper"
                    style="height: 500px;width: 100%;"
                    [text]="sampleStr"
                    mode="json">
  </micro-ace-editor>
</div>
